"use client";
import React from "react";
import {
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";

import { TeamCard, TeamCardElementType } from "@/components/TeamCard/TeamCard";
import buttonStyles from "../../components/Button/Button.module.scss";
import { fetchTeams } from "@/getData/fetchTeams";
import { mockTeamPost } from "@/ui/mock-data";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { Breakpoint } from "@aleksundshantu/aunds-utils-react/layout";
import { TeamGridProps } from "./TeamGrid.server";

const TeamGridClient = ({
  data,
  gridOptions,
  socialMedia,
  teamheaderOptions,
  gridItemWidth,
  cardHeadlineTag,
  initialPosts,
  initialTotalPosts,
}: TeamGridProps & {
  gridItemWidth: Record<Breakpoint, string>;
  cardHeadlineTag: "h2" | "h2-small" | "h3";
  initialPosts: TeamCardElementType[];
  initialTotalPosts: number;
}) => {
  const { posts_per_page } = data.layout;

  const {
    grid_options: { grid_navigation },
  } = gridOptions ?? {};

  const { locale } = useGlobalContext();
  {
    /* jscpd:ignore-start */
  }
  return (
    <Grid
      postsPerPage={posts_per_page}
      initialItems={initialPosts}
      initialTotalPosts={initialTotalPosts}
      fetchItems={({ page, postsPerPage, offset }) => {
        return fetchTeams({
          page,
          postsPerPage,
          offset,
          locale,
          module: data,
        });
      }}
      renderLoading
    >
      {(gridPosts, loading) => {
        return (
          <>
            <GridContent justifyContent="center" gap="2rem">
              {gridPosts.map((element, key) => {
                return (
                  <GridItem itemWidth={gridItemWidth} key={key}>
                    <TeamCard
                      skeleton={loading}
                      socialMedia={socialMedia}
                      team={
                        loading
                          ? mockTeamPost
                          : (element as TeamCardElementType)
                      }
                      gridOptions={gridOptions}
                      teamheaderOptions={teamheaderOptions}
                      headlineTag={cardHeadlineTag}
                    />
                  </GridItem>
                );
              })}
            </GridContent>
            <GridLoadMore
              grid_navigation={grid_navigation}
              buttonStyles={buttonStyles}
              iconPosition="left"
            />
          </>
        );
      }}
    </Grid>
  );

  {
    /* jscpd:ignore-end */
  }
};

export default TeamGridClient;
